
import { mapState, mapGetters, mapActions } from 'vuex';
import PaginatedReviewResourceView from '@/mixins/PaginatedReviewResourceView';
import SocialMediaType from '@/enums/SocialMediaType';
import UserRole from '@/enums/UserRole';
import ExternalEmbeddedSocialMediaInfoSection from './ExternalEmbeddedSocialMediaInfoSection';

export default {
  i18nComponentKey: 'WidgetProductReviewsExternal.components.External',
  name: 'External',
  components: { ExternalEmbeddedSocialMediaInfoSection },
  mixins: [PaginatedReviewResourceView],
  data() {
    return {
      COLUMN_GAP: 20
    };
  },
  computed: {
    ...mapState('reviewSettings', ['reviewSettings']),
    ...mapState('facebook', ['enableEmbeddedFacebook']),
    ...mapState('widget', ['isMobile']),
    ...mapGetters('widget', [
      'appHeaderShowable',
      'device',
      'headerSectionShowable',
      'showFilterSection'
    ]),
    defaultResourceParams() {
      return { fields: 'reviews.social_media_title,reviews.comments' };
    },
    displayOptions() {
      return {
        device: this.device,
        cols: this.widget.posts_per_line,
        gutter: this.columnGap,
        minCardWidth: this.minCardWidth
      };
    },
    processedReviews() {
      let reviews = this.reviews;
      if (this.widget.display_admin_comments_first) {
        reviews = reviews.map(review => ({
          ...review,
          comments: review.comments.sort(
            (a, b) =>
              UserRole.BRAND_MANAGER_ROLES.includes(b.user_role) -
              UserRole.BRAND_MANAGER_ROLES.includes(a.user_role)
          )
        }));
      }

      return reviews.map(review => ({
        ...review,
        comments: review.comments.slice(0, this.widget.comments_count_on_list)
      }));
    },
    columnGap() {
      return this.device === 'pc' ? 20 : 16;
    },
    minCardWidth() {
      return this.device === 'pc' ? 100 : 0;
    },
    contentsStyle() {
      return {
        '--min-height': this.showFilterSection ? '204px' : 'auto'
      };
    }
  },
  async mounted() {
    await this.fetchFacebooks();
    this.initFacebook();
  },
  methods: {
    ...mapActions('widget', ['openReviewPopup']),
    ...mapActions('facebook', ['fetchFacebooks', 'initFacebook']),
    isEmbeddedFacebook(socialMediaType) {
      return (
        this.enableEmbeddedFacebook &&
        socialMediaType === SocialMediaType.FACEBOOK
      );
    },
    submit(params) {
      this.searchResource(params);
    }
  }
};
